module.exports = __webpack_public_path__ + "img/PC_06.371291dc.jpg";